export default "__VITE_ASSET__CBpHN8UQ__"